import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { BehaviorSubject } from 'rxjs';
import { BadgeColorsEnum } from 'src/app/shared/interfaces/BadgeColorsEnum';
import { InventoryLocationStatusEnum } from 'src/app/shared/interfaces/InventoryLocationStatusEnum';
import { InventoryLocationTypeEnum } from 'src/app/shared/interfaces/InventoryLocationTypeEnum';
import { IInventoryLocation } from 'src/app/shared/interfaces/inventory-location.interface';
import { AlertMessageService } from 'src/app/shared/services/alert-message.service';
import { RemoveInventoryLocation, UpdateActivityForInventoryLocation } from 'src/app/shared/states/settings/settings.actions';
import { SettingsState } from 'src/app/shared/states/settings/settings.state';

@UntilDestroy()
@Component({
  selector: 'app-inventory-locations-table',
  templateUrl: './inventory-locations-table.component.html',
  styleUrls: ['./inventory-locations-table.component.scss']
})
export class InventoryLocationsTableComponent implements OnInit {

  @Input() inventoryLocationList: IInventoryLocation[] = [];

  InventoryLocationStatusEnum = InventoryLocationStatusEnum;
  BadgeColorsEnum = BadgeColorsEnum;
  InventoryLocationTypeEnum = InventoryLocationTypeEnum;

  showRemoveLocationDialog$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private locationId: string;
  
  @Output() editLocation: EventEmitter<string> = new EventEmitter();
  /**
   *
   */

  @ViewChild('tableRowMenu') tableRowMenu;

  constructor(private store: Store, private messageService: AlertMessageService) {
    
  }

  ngOnInit(): void {
    
  }

  openRemoveLocationDialog(rowData: IInventoryLocation): void {
    this.locationId = rowData.id;
    this.showRemoveLocationDialog$.next(true);
    this.tableRowMenu.close();
  }

  locationRemovalConfirmed(): void {
    if (this.locationId) {
      this.store.dispatch(new RemoveInventoryLocation(this.locationId)) 
      .pipe(untilDestroyed(this))
      .subscribe(res => {
       if (this.store.selectSnapshot(SettingsState).cannotRemoveInventoryLocationAsLocationIsNotEmpty) {
          this.messageService.alertMessage$.next({
            content: 'Cannot remove location as it is not empty',
             type: 'error-info', 
             autoHide: 10, 
             closeButtonName: null, 
             width: 'fit-content'
            });
       }
       this.showRemoveLocationDialog$.next(false);
       this.locationId = null;
      })
    }
  }

  setActivityStatus(rowData, activity: boolean): void {
    this.store.dispatch(new UpdateActivityForInventoryLocation({locationId: rowData.id, isActive: activity })) 
    .pipe(untilDestroyed(this))
    .subscribe(res => {
     if (this.store.selectSnapshot(SettingsState).cannotDeactivateAsLocationIsNotEmpty) {
      this.messageService.alertMessage$.next({
        content: 'Cannot de-activate locations that still contain inventory.  Please move all inventory from this location first',
         type: 'error-info', 
         autoHide: 10, 
         closeButtonName: null, 
         width: 'fit-content'
        });
     }
    })
  }


}
